// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1mVLK","author":"Table_author__2Roh8","authorImage":"Table_authorImage__1RQ7E","unreadRow":"Table_unreadRow__2GNeO"};